export default __webpack_public_path__ + "static/media/Shareholding Pattern.3103d23e.pdf";